class ContentSlider {
  constructor({ main }) {
    this.dom = {
      main: main
    }

    this.InitSlider();
  }


  InitSlider() {
    const flickityOptions = JSON.parse(this.dom.main.getAttribute('data-flickity-config'));

    if (!flickityOptions) return

    this.flickityInstance = new Flickity(this.dom.main, flickityOptions);

    var lastWidth = window.innerWidth;

    window.addEventListener('resize', () => {
      if (window.innerWidth !== lastWidth) {
        this.flickityInstance.resize();
        lastWidth = window.innerWidth;
      }
    }); 

    if (window.ResizeObserver && this.flickityInstance) {
      this.resizeObserver = new ResizeObserver(() => {
        this.flickityInstance.resize();
      });

      this.dom.main.querySelectorAll('.Carousel__Cell').forEach((item) => {
        this.resizeObserver.observe(item);
      });
    }

    this.dom.main.style.height = 'auto'
  }
}

const initContentSliders = () => {
  const contentSliders = document.querySelectorAll('[data-section-type="content-slider"]');
  
  contentSliders.forEach(contentSlider => {
    new ContentSlider({ main: contentSlider });
  });
}

if (document.readyState === 'complete' || document.readyState === 'interactive') {
  initContentSliders();
} else {
  document.addEventListener('DOMContentLoaded', () => initContentSliders(), {
    once: true,
  });
}